export const IS_PERMISSION = "IS_PERMISSION";
export const IS_NOTPERMISSION = "IS_NOTPERMISSION";